import { SharedConstants } from "../../../../shared/constants/shared.constants";
export var PvprojectCycleHeadingEnum;
(function (PvprojectCycleHeadingEnum) {
    PvprojectCycleHeadingEnum["Name"] = "Name";
    PvprojectCycleHeadingEnum["Description"] = "Description";
    PvprojectCycleHeadingEnum["FromDate"] = "From date";
    PvprojectCycleHeadingEnum["ToDate"] = "To date";
    PvprojectCycleHeadingEnum["Completed"] = "Completed";
    PvprojectCycleHeadingEnum["Documents"] = "Project documentation";
})(PvprojectCycleHeadingEnum || (PvprojectCycleHeadingEnum = {}));
export const PvprojectCycleConfigHeadingLookup = new Map([
    [PvprojectCycleHeadingEnum.Name, "name"],
    [PvprojectCycleHeadingEnum.Description, "description"],
    [PvprojectCycleHeadingEnum.FromDate, "fromDate"],
    [PvprojectCycleHeadingEnum.ToDate, "toDate"],
    [PvprojectCycleHeadingEnum.Completed, "completedString"]
]);
export class PvprojectCycleConstants {
    static REMOVE_TITLE = `${SharedConstants.REMOVE_TITLE} project cycle`;
    static REMOVE_MESSAGE = `${SharedConstants.REMOVE_MESSAGE} project cycle(s)?`;
    static COMPONENT_NAME = "Project cycle component";
    static MODAL_OPTIONS = {
        size: "xl",
        centered: true,
        backdrop: "static"
    };
    static DELETE_CLOSED_ERROR = "Unable to delete valuation blocks that are complete";
    static SET_PARAMETERS_LABEL = "Set parameters";
}
